module.exports = import("/link-analysis/remoteEntry.js");